import { QueuedIntakeFileInfo, UploadData } from '../../../store/uploadStore';
import getPilotApiService from '../../../api_services/PilotApiService';
import { UploadNotRestoredError } from '../../../errors/UploadNotRestoredError';
import { UpdateIntakePhotosInfo } from '../../../types';
import { calcHash } from '../../../libs/file';
import { trackFileRegistrationTime } from './measurements/trackFileRegistrationTime';

export const registerFileInPilotApi = async (upload: UploadData, file: QueuedIntakeFileInfo) => {
  if (!upload.upload) throw new UploadNotRestoredError();

  const { cameraModel, coords, fileCategory, name, takenAt, datePrecise, validation } = file;
  const fileHash = calcHash(file.file);

  const photos: UpdateIntakePhotosInfo = {
    // Unnecessary fields for the current file category are set to "undefined" and will be excluded
    [fileHash]: {
      cameraModel,
      coords,
      fileCategory,
      name,
      takenAt,
      // Persisted so that a restored upload still knows which of its photos carry a GPS timestamp.
      datePrecise,
      uploaded: true,
      validation,
    },
  };

  const timeStart = Date.now();
  await getPilotApiService().updateIntakeFlow(
    upload.meta.abortController.signal,
    upload.upload.customer,
    upload.upload.site,
    upload.meta.type,
    upload.upload.date,
    {
      photos,
    },
    upload.upload.flightScheduleId,
  );
  trackFileRegistrationTime(Date.now() - timeStart);
};
